import {gql} from '@apollo/client';

export const DELETE_SORTER_PLAN = gql`
    mutation DeleteSorterPlan($id: Long!) {
        deleteSorterPlan(id: $id)
    }
`;

